export const genreOptions = ['全部', '动作', '科幻', '剧情', '犯罪', '悬疑', '古装', '奇幻', '爱情', '家庭', '搞笑', '冒险', '运动', '都市', '青春', '职场'];

export const regionOptions = ['全部', '中国大陆', '中国香港', '中国台湾', '美国', '韩国', '日本', '英国'];

export const yearOptions = ['全部', '2026', '2025', '2024', '2023', '2022', '更早'];

export const ratingOptions = ['全部', '9.0 分以上', '8.5 分以上', '8.0 分以上', '7.5 分以上'];

export const sortOptions = [
  { key: 'latest', label: '最新上映' },
  { key: 'hot', label: '热度优先' },
  { key: 'rating', label: '评分最高' },
];

export const categoryMeta = {
  movie: {
    name: '电影',
    title: '电影分类',
    desc: '精选国内外热门电影，涵盖动作、科幻、剧情、悬疑等多种类型，支持按类型、地区与年份快速筛选。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20cinema%20hall%20with%20glowing%20red%20seats%20and%20a%20large%20blank%20screen%2C%20warm%20dark%20tones%2C%20atmospheric%20banner&width=1600&height=600&seq=mc-cat-movie&orientation=landscape',
  },
  tv: {
    name: '电视剧',
    title: '电视剧分类',
    desc: '热播剧集与经典长剧一网打尽，古装、都市、悬疑、家庭多种题材随心筛选，追剧不再迷路。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20and%20warm%20lamp%20light%2C%20cinematic%20banner%2C%20moody%20tones&width=1600&height=600&seq=mc-cat-tv&orientation=landscape',
  },
  variety: {
    name: '综艺',
    title: '综艺分类',
    desc: '汇集热门综艺与真人秀，音乐、美食、竞技、推理应有尽有，轻松娱乐一整天。',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20television%20studio%20stage%20with%20colorful%20spotlights%20and%20confetti%2C%20energetic%20banner%2C%20bright%20playful%20colors&width=1600&height=600&seq=mc-cat-variety&orientation=landscape',
  },
};

export const aboutContent = {
  intro:
    '蘑菇视频是一个面向广大影视爱好者的综合影视资讯平台。我们聚合电影、电视剧、综艺等多类型影视内容，提供最新影视资讯、分类筛选、精准搜索与高清视频观看入口，致力于让每一次找片、追剧与观影都更简单、更愉快。',
  mission: '让好内容被更快发现，让每一次观看都值得。',
  email: 'contact@mushroom-video.com',
};